import { Outlet } from "react-router-dom";
import Nav from "@/components/layout/Nav";
import Footer from "@/components/layout/Footer";
import { WhatsAppFAB } from "@/components/ui-extras/WhatsApp";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-cream text-ink">
      <a href="#main" className="skip-link" data-testid="skip-to-content">
        Naar hoofdinhoud
      </a>
      <Nav />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFAB />
    </div>
  );
}
